import React, { useState } from 'react'
import { Row, Col, Modal, Button, Divider } from 'antd'
import * as img from './img'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { backtoTopFunction } from './components/BacktoTop'

const RecentProject = () => {
  const [modalvisible, modalsetVisible] = useState(false)
  const navi = useNavigate()

  return (
    <div
      className="site-layout-background center-img-grid"
      // className= {window.innerWidth > 450 ? "site-layout-background center-img-grid" : "site-layout-background"}
    >
      <Modal
        title="Title : PROJECT A "
        centered
        visible={modalvisible}
        onOk={() => modalsetVisible(false)}
        onCancel={() => modalsetVisible(false)}
        footer={[
          <Button key="back" onClick={() => modalsetVisible(false)}>
            Back
          </Button>,
          <Button
            key="link"
            type="primary"
            // loading={loading}
            // onClick={this.handleOk}
          >
            Details
          </Button>,
        ]}
        width={1000}
      >
        <img
          // src={img.arknight}
          className="imgmodaldetail"
          alt="noImg"
          onClick={() => {
            modalsetVisible(true)
          }}
        />
        <p>some description...</p>
        {/* <Button> Details</Button> */}
      </Modal>

      <motion.div
        // initial={{ opacity: 0, x: -1000 }}
        // animate={{ opacity: 1, x: 0 }}
        transition={{ ease: 'easeIn', duration: 0.8 }}
        whileInView={{ opacity: [0, 1], x: [-100, 0] }}
      >
        <Divider orientation="left">
          <h2>My Projects </h2>
        </Divider>
        <h3 style={{ paddingLeft: '3vw' }}>Click image to view my projects </h3>

        <div
          className={
            window.innerWidth > 450
              ? 'site-layout-background center-img-grid'
              : 'site-layout-background'
          }
        >
          <Row gutter={[8, 16]}>
            {img.sliderimg.map((index, i) => (
              <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                <motion.div
                  whileHover={{ y: -15 }}
                  whileTap={{ scale: 0.9, zIndex: 1 }}
                >
                  <img
                    src={index.img}
                    className="imgproject"
                    alt="noImg"
                    onClick={() => {
                      backtoTopFunction()
                      navi('/project')
                    }}
                  />
                  <h3>{index.title}</h3>
                </motion.div>
              </Col>
            ))}
          </Row>
          <hr />
        </div>
      </motion.div>
    </div>
  )
}

export default RecentProject
